import React from "react";
const Kba = window.dreamchimney.kba;
const KbaRender = ({ margin = "60px auto" }) => (
  <div style={{ display: "block", textAlign: "center", margin }}>
    <Kba destination="tracks" />
  </div>
);

export default KbaRender;
